import React from "react";
import T from "prop-types";

import { PlaceholderText } from "2g-placeholder";

export function ZakaznikDetailTitleDescription({ zakaznik, loading }) {
  return loading ? (
    <PlaceholderText>
      <span className="b2b-ZakaznikDetail-description">
        <span>Lorem Ipsum dolor sit</span>
        <span>IČO: 2569841258</span>
      </span>
    </PlaceholderText>
  ) : (
    <span className="b2b-ZakaznikDetail-description">
      <span>{zakaznik.adresa}</span>
      <span>IČO: {zakaznik.ico}</span>
    </span>
  );
}

ZakaznikDetailTitleDescription.propTypes = {
  loading: T.bool,
  zakaznik: T.object
};

export default React.memo(ZakaznikDetailTitleDescription);
